import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cross-bold",
  "use": "icon-cross-bold-usage",
  "viewBox": "0 0 9.1 9.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 9.1 9.1\" id=\"icon-cross-bold\">\r\n<g>\r\n\t<path d=\"M8.1,9.1C7.8,9.1,7.6,9,7.4,8.8L4.5,6L1.7,8.8c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l2.8-2.8L0.3,1.7c-0.4-0.4-0.4-1,0-1.4\r\n\t\ts1-0.4,1.4,0l2.8,2.8l2.8-2.8c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L6,4.5l2.8,2.8c0.4,0.4,0.4,1,0,1.4C8.6,9,8.3,9.1,8.1,9.1z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol